export const workflowIssues = [
    {
        icon: '/img/Delayed check in out.png',
        title: 'Delayed check-in check-out',
    },
    {
        icon: '/img/Lack of visual evidence.png',
        title: 'Lack of visual evidence',
    },
    {
        icon: '/img/Scaling challenges.png',
        title: 'Scaling challenges',
    },
    {
        icon: '/img/Inconsistence and subjectivity.png',
        title: 'Inconsistent & Subjectivity',
    },
    {
        icon: '/img/Reduce resale value.png',
        title: 'Reduce resale value',
    }
];

export const builtForList = [
    {
        icon: '/img/Contactless vehicle scanning.png',
        title: 'Contactless vehicle scanning(via smartphone image Detection)',
    },
    {
        icon: '/img/Instant condition report.png',
        title: 'Instant condition report',
    },
    {
        icon: '/img/Digital record keeping.png',
        title: 'Digital record-keeping',
    },
    {
        icon: '/img/Transparent process.png',
        title: 'Transparency throughout the process',
    },
    {
        icon: '/img/Fewer damage disputes.png',
        title: 'Fewer damage disputes',
    }
];

export const stats = [
    {
        value: '80%',
        label: 'Lesser disputes'
    },
    {
        value: '2x',
        label: 'Faster vehicle turnaround'
    },
    {
        value: '3min',
        label: 'or less per inspection'
    },
    {
        value: '100%',
        label: 'saving on operational costs'
    }
];

export const capabilities = [
    {
        icon: '/img/Automated check in out.png',
        title: 'Automated Check-in/Check-out',
        text: 'for vehicle internal'
    },
    {
        icon: '/img/Lease Inspection.png',
        title: 'Lease Inspection',
        text: 'End of lease inspection for leased vehicles'
    },
    {
        icon: '/img/Automate repair estimation.png',
        title: 'Automate repair estimation',
        text: 'in case of accidents'
    },
];

